import { SvgXml } from 'react-native-svg'
import { source } from './amount-swap-source'

export function AppIconAmountSwap({ size = 16 }: { size?: number; color?: string }) {
  return <SvgXml xml={source} width={size} height={size} />
}
